import React from "react";
import "../../day-plan-styles/WarningPrompt.css";
import { useTranslation } from "@preppa/translation";
//SKAPA Components
import SSRIcon from "@ingka/ssr-icon";
import Button from "@ingka/button";
//SKAPA Styles
import "@ingka/hyperlink/dist/style.css";
import "@ingka/forms/dist/style.css";
//SKAPA Icons
import warningIcon from "@ingka/ssr-icon/paths/warning-triangle";

interface WarningPromptProps {
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
}

function WarningPrompt({
  message,
  onConfirm,
  onCancel,
}: WarningPromptProps) {
  const { translate } = useTranslation();

  return (
    <div id="warning-prompt-wrapper">
      <div id="warning-prompt-header">
        <SSRIcon
          className="card-icon"
          paths={warningIcon}
          color="black"
          viewBox="2 2 20 20"
        />
        <span>{translate("dayPlan.prompts.warning")}</span>
      </div>
      <div id="warning-prompt-content">
        <p>{message}</p>
      </div>
      <div id="warning-prompt-button-container">
        <Button
          text={translate("dayPlan.prompts.ok")}
          type="emphasised"
          size="small"
          onClick={onConfirm}
        />
        <Button
          text={translate("dayPlan.prompts.cancel")}
          type="secondary"
          size="small"
          onClick={onCancel}
        />
      </div>
    </div>
  );
}

export default WarningPrompt;
